import {
  BUGGIES_CATEGORY1_ID,
  CLASSICS_CATEGORY1_ID,
  DEFAULT_OFFER_TYPE_ID,
  MINIMOTOS_CATEGORY1_ID,
  MOTOS_CATEGORY1_ID,
  OFFER_TYPE_NEW,
  QUADS_CATEGORY1_ID,
  UNSELECTED_OFFER_TYPE
} from './ads.js'
import {PROFESSIONAL_STOCK_PAGE_NAME, PROFESSIONAL_STOCK_RENTING_PAGE_NAME} from './page.js'

export const DEFAULT_BIG_BANNER_ENABLED_RESPONSE = false
export const NO_ADVERTISING_PAGES = [PROFESSIONAL_STOCK_PAGE_NAME, PROFESSIONAL_STOCK_RENTING_PAGE_NAME]

export const PubRight1 = 'PubRight1'
export const PubRight2 = 'PubRight2'
export const PubLeft1 = 'PubLeft1'
export const PubLeft2 = 'PubLeft2'
export const PubInline1Desktop = 'PubInline1Desktop'
const PubInline2Desktop = 'PubInline2Desktop'
const PubInline1Mobile = 'PubInline1Mobile'
const PubInline2Mobile = 'PubInline2Mobile'
const PubInline3Mobile = 'PubInline3Mobile'
export const PubPhoto = 'PubPhoto'
export const PubTop1 = 'PubTop1'
export const PubTopC = 'PubTopC'
export const TextAds = 'TextAds'

export const AD_INLINE_BANNER_DESKTOP = 'bannerDesktop'
export const AD_INLINE_BANNER_MOBILE = 'inlineMobile'
export const AD_FORMAT_NATIVE_DESKTOP = 'nativeDesktop'
export const AD_FORMAT_NATIVE_MOBILE = 'nativeMobile'

export const EVENT_CHANNEL_INSURANCE = 'marketplace insurances'
export const EVENT_ID_DETAIL_CLICKED = 'insurances detail clicked'
export const EVENT_INSURANCE_CLICKED = 'Event Fired'
export const URL_INSURANCE_BUTTON = 'https://motos.coches.net/seguros/?$$DATALAYER_PARAMS$$'

export const ADS_LIST_POSITIONS = {
  [PubTopC]: {
    id: 'ad-top-c'
  },
  [TextAds]: {
    id: 'ad-textads'
  },
  [PubInline1Mobile]: {
    position: 5,
    format: AD_FORMAT_NATIVE_MOBILE,
    isMobile: true,
    isDesktop: false,
    id: 'ad-inline-1'
  },
  [PubInline2Mobile]: {
    position: 8,
    format: AD_INLINE_BANNER_MOBILE,
    isMobile: true,
    id: 'ad-inline-2'
  },
  [PubInline3Mobile]: {
    position: 22,
    format: AD_INLINE_BANNER_MOBILE,
    isMobile: true,
    id: 'ad-inline-3'
  },
  [PubInline1Desktop]: {
    position: 9,
    format: AD_FORMAT_NATIVE_DESKTOP,
    isDesktop: true,
    isMobile: false,
    id: 'ad-inline-1'
  },
  [PubInline2Desktop]: {
    position: 19,
    format: AD_FORMAT_NATIVE_DESKTOP,
    isDesktop: true,
    id: 'ad-inline-2'
  },
  [PubTop1]: {
    id: 'ad-top-1'
  },
  [PubRight1]: {
    id: 'ad-right-1'
  },
  [PubRight2]: {
    id: 'ad-right-2'
  },
  [PubLeft1]: null,
  [PubLeft2]: null,
  [PubPhoto]: {
    id: 'ad-photo'
  }
}

export const SEGMENTATION_CHANGED_EVENT_NAME = 'MOTOS_SEGMENTATION_CHANGED'

export const CATEGORIES_LEVEL_1 = {
  [MOTOS_CATEGORY1_ID]: {'es-ES': 'Motos'},
  [QUADS_CATEGORY1_ID]: {'es-ES': 'Quads y ATV'},
  [BUGGIES_CATEGORY1_ID]: {'es-ES': 'Buggy'},
  [MINIMOTOS_CATEGORY1_ID]: {'es-ES': 'Minimoto'},
  [CLASSICS_CATEGORY1_ID]: {'es-ES': 'Clásicas y competición'}
}

export const VEHICLE_STATUS = {
  [-1]: {'es-ES': 'Ocasión'},
  0: {'es-ES': 'Ocasión'},
  1: {'es-ES': 'Nuevo'}
}

export const FUEL_TYPES = {
  2: {'es-ES': 'Gasolina'},
  3: {'es-ES': 'Eléctrico'}
}

const ADS_NAME_PAGE_BASE = 'motosnet'
export const ADS_NAME_PAGE_ADS_LIST_BASE = 'home'
export const ADS_NAME_PAGE_AD_DETAILS_BASE = 'ficha'
export const ADS_NAME_PAGE_AD_DETAILS_GALLERY_BASE = 'foto'

const ADS_NAME_PAGE_SECOND_HAND_OFFER_TYPE = 'ocasion'
const ADS_NAME_PAGE_NEW_OFFER_TYPE = 'nuevas'

const ADS_NAME_PAGE_SECOND_HAND_BASE = `${ADS_NAME_PAGE_BASE}/${ADS_NAME_PAGE_SECOND_HAND_OFFER_TYPE}`
const ADS_NAME_PAGE_NEW_BASE = `${ADS_NAME_PAGE_BASE}/${ADS_NAME_PAGE_NEW_OFFER_TYPE}`

const ADS_NAME_PAGE_MOTOS_CATEGORY1_ID_DEFAULT_OFFER_TYPE_ID = ADS_NAME_PAGE_SECOND_HAND_BASE
const ADS_NAME_PAGE_MOTOS_CATEGORY1_ID_OFFER_TYPE_NEW = ADS_NAME_PAGE_NEW_BASE
const ADS_NAME_PAGE_QUADS_CATEGORY1_ID_DEFAULT_OFFER_TYPE_ID = ADS_NAME_PAGE_SECOND_HAND_BASE
const ADS_NAME_PAGE_QUADS_CATEGORY1_ID_OFFER_TYPE_NEW = ADS_NAME_PAGE_NEW_BASE
const ADS_NAME_PAGE_BUGGIES_CATEGORY1_ID_DEFAULT_OFFER_TYPE_ID = ADS_NAME_PAGE_SECOND_HAND_BASE
const ADS_NAME_PAGE_BUGGIES_CATEGORY1_ID_OFFER_TYPE_NEW = ADS_NAME_PAGE_NEW_BASE
const ADS_NAME_PAGE_MINIMOTOS_CATEGORY1_ID_DEFAULT_OFFER_TYPE_ID = ADS_NAME_PAGE_SECOND_HAND_BASE
const ADS_NAME_PAGE_MINIMOTOS_CATEGORY1_ID_OFFER_TYPE_NEW = ADS_NAME_PAGE_SECOND_HAND_BASE
const ADS_NAME_PAGE_CLASSICS_CATEGORY1_ID_DEFAULT_OFFER_TYPE_ID = ADS_NAME_PAGE_NEW_BASE

export const ADS_NAME_PAGE_MAP = {
  [MOTOS_CATEGORY1_ID]: {
    [DEFAULT_OFFER_TYPE_ID]: ADS_NAME_PAGE_MOTOS_CATEGORY1_ID_DEFAULT_OFFER_TYPE_ID,
    [OFFER_TYPE_NEW]: ADS_NAME_PAGE_MOTOS_CATEGORY1_ID_OFFER_TYPE_NEW,
    [UNSELECTED_OFFER_TYPE]: ADS_NAME_PAGE_MOTOS_CATEGORY1_ID_DEFAULT_OFFER_TYPE_ID
  },
  [QUADS_CATEGORY1_ID]: {
    [DEFAULT_OFFER_TYPE_ID]: ADS_NAME_PAGE_QUADS_CATEGORY1_ID_DEFAULT_OFFER_TYPE_ID,
    [OFFER_TYPE_NEW]: ADS_NAME_PAGE_QUADS_CATEGORY1_ID_OFFER_TYPE_NEW
  },
  [BUGGIES_CATEGORY1_ID]: {
    [DEFAULT_OFFER_TYPE_ID]: ADS_NAME_PAGE_BUGGIES_CATEGORY1_ID_DEFAULT_OFFER_TYPE_ID,
    [OFFER_TYPE_NEW]: ADS_NAME_PAGE_BUGGIES_CATEGORY1_ID_OFFER_TYPE_NEW
  },
  [MINIMOTOS_CATEGORY1_ID]: {
    [DEFAULT_OFFER_TYPE_ID]: ADS_NAME_PAGE_MINIMOTOS_CATEGORY1_ID_DEFAULT_OFFER_TYPE_ID,
    [OFFER_TYPE_NEW]: ADS_NAME_PAGE_MINIMOTOS_CATEGORY1_ID_OFFER_TYPE_NEW
  },
  [CLASSICS_CATEGORY1_ID]: {
    [DEFAULT_OFFER_TYPE_ID]: ADS_NAME_PAGE_CLASSICS_CATEGORY1_ID_DEFAULT_OFFER_TYPE_ID
  }
}

export const ADVERTISING_SITE = 'mn'

export const INSURANCE_CARD_CTA = 'VER OFERTA'
export const INSURANCE_PRODUCT_ID = 'insurance-bike-v2'
export const INSURANCE_DETAIL_CARD_LOGOS_URL = `https://adit.gw.coches.net/twintail/v1/product/${INSURANCE_PRODUCT_ID}/logos/mosaic`
export const INSURANCE_DETAIL_CARD_LOGOS = [
  {name: 'Mutua Madrileña', url: 'https://a.dcdn.es/services/images/players/logo-rv/18.png'},
  {name: 'AMV', url: 'https://adit.gw.coches.net/twintail/v1/product/logos/60952365-92e8-4f4e-9a03-a56cab208c42'},
  {
    name: 'Línea Directa',
    url: 'https://adit.gw.coches.net/twintail/v1/product/logos/7657a676-f266-4462-bb0e-186b8f706618'
  }
]

export const DEFAULT_MAKE = 0
